import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./PartsFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";

import { useEffect, useState } from "react";

import PartsFormStepOne from "./PartsFormSteps/PartsFormStepOne";
import { useTranslation } from "react-i18next";

const PartsForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);
  const { t } = useTranslation();
  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        manufacturer: Boolean(_initialValues?.manufacturer)
          ? {
              uuid: _initialValues?.manufacturer?.uuid,
              label: _initialValues?.manufacturer?.entryName,
            }
          : null,
        substitute: _initialValues.substitute
          ? {
              name:
                _initialValues.substitute === "YES"
                  ? t("global:yes")
                  : t("global:no"),
              value: _initialValues.substitute,
            }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={false}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="LeasingForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <PartsFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default PartsForm;
